import React from "react";
import styles from "./blur-text.module.css";

const BlurText = () => {
  return (
    <div className={styles.text_container}>This last card slightly disrupts your previous two draws. This case is unique and no more than 5% of have such a case.</div>
  );
}

export { BlurText };